<template>
  <v-timeline-item color="orangePcm" fill-dot small>
    <v-card>
      <v-row dense>
        <v-col cols="12">
          <v-card-title>
            Final Ligação
          </v-card-title>
        </v-col>
      </v-row>
      <v-row align="center" align-content="center" dense>
        <v-col>
          <v-card-text> <strong>Data final: </strong> {{ convertDateFormat(item.dateEndCall) }} </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <strong>Desligado por: </strong> {{ ligacaoCaiu(item.hangupSource, item.numeroDestino) }}
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <strong>Tempo Total: </strong> {{ getAnyTimeCall(item.status, item.dateStartCall, item.dateEndCall) }}
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <strong>Conversação: </strong> {{ getAnyTimeCall(item.status, item.dataAtdCall, item.dateEndCall) }}
          </v-card-text>
        </v-col>
        <v-col v-if="item.protocol != undefined">
          <v-card-text v-if="item.protocol[0] != undefined" >
            <strong>Protocolo: </strong> {{ item.protocol[0] }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-timeline-item>
</template>

<script>
import { sharedMethods } from '../_utils/sharedMethods'

export default {
  props: {
    item: Object,
  },
  methods: {
    ...sharedMethods,

    ligacaoCaiu(hangupSource, numeroDestino) {
      console.log(hangupSource.split('-')[0].split('/')[1])
      if (hangupSource.includes('PJSIP/')) {
        if (hangupSource.includes('.')) {
          return numeroDestino
        }
        return hangupSource.split('-')[0].split('/')[1]
      }
      if(hangupSource.includes('Khomp/')){
        return hangupSource.split('-')[0].split('/')[1]
      }

      return hangupSource
    },
  },
}
</script>
